import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import {FileListItem} from "./FileListItem";
import { useGlobalUpload } from "../lib/GlobalUploadContext";
import { UPLOADING_STATUS } from "../constants";

const GlobalUploadWidget = () => {
    const { files, status, setFiles, setStatus } = useGlobalUpload();

    const isVisible =
        files.length > 0 && status === UPLOADING_STATUS.Loading;

    if (!isVisible) return null;

    return (
        <Box
            sx={{
                position: "fixed",
                bottom: 16,
                right: 16,
                zIndex: 1500,
                width: 400,
                maxHeight: "60vh",
                overflowY: "auto",
            }}
        >
            <Paper elevation={4} sx={{ padding: 2 }}>
                {files.map((file, index) => (
                    <FileListItem
                        key={file.name}
                        file={file}
                        index={index}
                        files={files}
                        setFiles={setFiles}
                        setStatus={setStatus}
                        status={status}
                        compact // можно добавить проп для уменьшенного отображения
                    />
                ))}
            </Paper>
        </Box>
    );
};

export default GlobalUploadWidget;
